
import './viewAllPendingRejections.css';
import React, { useState, useEffect } from "react";

import jwt from 'jwt-decode';
import { GET_APPLICATION_LIST, GET_ALL_STAKEHOLDERS } from '../../../common/URLs';
import back from '../../../images/backButton.png';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom';
import { Fab, IconButton, Tooltip } from '@mui/material';
import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import { PROD } from '../../../common/constants';
import { Box, CardContent, Card, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { lastFiveDigitsComparator } from '../../../common/commonFunction';
import { useTranslation } from 'react-i18next';
import { ViewIcon } from '../../../common/icons';
import apiClient from '../../../axios';

function ViewAllPendingRejections() {
  const { t } = useTranslation();
  const [stakeHolders, setStakeHolders] = useState();
  const [viewPendingRejections, setViewPendingRejections] = useState();
  const [userID, setUserId] = useState();
  useEffect(() => {

    setUserId(location.state.userid);

  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state.userid;
  const backScrutiny = location.state.backScrutiny;
  useEffect(() => {
    if (userId) {
      getAllPendingRejections();
    }
  }, [userId]);
  const onView = (urnSelected, createdBy, stakeholderType, growerSubCategory) => {
    const userData = {
      "urnSelected": urnSelected,
      "createdBy": createdBy,
      "userId": userId,
      "isScrutinyView": true

    }
    if (backScrutiny === true) {
      if(stakeholderType === "Transporter") {
        navigate("/registrationHome/scrutiny/registrationDetailsTransporter", { state: { data: userData, URN: urnSelected } });
      }
      else if(stakeholderType === "HIT") {
        navigate("/registrationHome/scrutiny/registrationDetailsHit", { state: { data: userData, URN: urnSelected } });
      }
      else if(stakeholderType === "LLE") {
        navigate("/registrationHome/scrutiny/registrationDetailsLle", { state: { data: userData, URN: urnSelected } });
      }
      else if(stakeholderType === "Interim Storage Operator") {
        navigate("/registrationHome/scrutiny/registrationDetailsTempStorage", { state: { data: userData, URN: urnSelected } });
      }
      else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
        navigate("/registrationHome/scrutiny/registrationDetails", { state: { data: userData, URN: urnSelected } })
      }
      else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || growerSubCategory === "FPC") {
        navigate("/registrationHome/scrutiny/registrationMemberDetails", { state: { data: userData, URN: urnSelected } })
      }
      else if (growerSubCategory === "Forest") {
        navigate("/registrationHome/scrutiny/registrationDetailsForest", { state: { data: userData, URN: urnSelected } })
      }
      else {
        // navigate("/registrationHome/scrutiny/onView", { state: { data: userData } })
      }
    }
    else {
      if(stakeholderType === "Transporter") {
        navigate("/registrationHome/dashboard/registrationDetailsTransporter", { state: { data: userData, URN: urnSelected } });
      }
      else if(stakeholderType === "HIT") {
        navigate("/registrationHome/dashboard/registrationDetailsHit", { state: { data: userData, URN: urnSelected } });
      }
      else if(stakeholderType === "LLE") {
        navigate("/registrationHome/dashboard/registrationDetailsLle", { state: { data: userData, URN: urnSelected } });
      }
      else if(stakeholderType === "Interim Storage Operator") {
        navigate("/registrationHome/dashboard/registrationDetailsTempStorage", { state: { data: userData, URN: urnSelected } });
      }
     else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
        navigate("/registrationHome/dashboard/registrationDetails", { state: { data: userData, URN: urnSelected } })
      }
      else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || stakeholderType === "FPC") {
        navigate("/registrationHome/dashboard/registrationMemberDetails", { state: { data: userData, URN: urnSelected } })
      }
      else if (growerSubCategory === "Forest") {
        navigate("/registrationHome/dashboard/registrationDetailsForest", { state: { data: userData, URN: urnSelected } })
      }
      else {
        // navigate("/registrationHome/dashboard/onView", { state: { data: userData } })
      }
    };
  }

function getAllPendingRejections() {
  apiClient
    .post(GET_APPLICATION_LIST,
      {
        "userID": userId,
        "status": "Pending_Rejection",
        "regStatus": location?.state?.isResourceUpdate
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setViewPendingRejections(response.data);
    })
    .catch(function (error) {
      console.log(error);
    });
}
const PendingRejectionsArray = viewPendingRejections?.scrutinyWorkFlowStepDetails;
const columns = [
    {
        field: 'id', headerName: 'S.No', width: 60,
        renderCell: (index) => index.api.getRowIndex(index.row.id) + 1
    },
    { field: 'name', headerName: t('preReg.name'), width: 200 },
    { field: 'urn', headerName: 'URN', width: 200, sortComparator: (a, b) => lastFiveDigitsComparator(a, b) },
    { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 200 },
    { field: 'registrationStatus', headerName: 'Status', width: 200 },
    { field: 'totalQuantity', headerName: 'Total Quantity (in MT)', width: 140, type: "number" },
    { field: 'committedQuantity', headerName: 'Committed Quantity (in MT)', width: 140, type: "number" },
  {
    field: 'action', headerName: 'Action', width: 150,
    renderCell: (cellValues) => {
      return (
        <Tooltip title="View">
        <IconButton
          color="primary"
          onClick={() => onView(cellValues?.row?.urn, cellValues?.row?.createdBy, cellValues?.row?.stakeholderType, cellValues?.row?.stakeholderSubCategory)}
        >
          <ViewIcon/>
        </IconButton>
        </Tooltip>
      );
    }
  },
];

return (
  <>
    {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG50</p>}
    <Card>
      <CardContent>
        <div style={{ display: "inline-flex" }}>
          <Typography variant="h4" sx={{ mb: 2 }}>
            <Fab component={RouterLink} to={backScrutiny === true ? '../scrutiny' : '../dashboard'} size="small" aria-label="back" title='Back'>
              <KeyboardArrowLeftRounded />
            </Fab>
          </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <div className="hitDetailsText">Pending Rejections</div>
        </div>
        {PendingRejectionsArray &&
          <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
            <DataGrid
              sx={{
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal",
                  lineHeight: "normal"
                },
                "& .MuiDataGrid-columnHeader": {
                  height: "unset !important"
                },
                "& .MuiDataGrid-columnHeaders": {
                  maxHeight: "168px !important"
                }
              }}
              rows={PendingRejectionsArray}
              columns={columns}
              pageSize={10}
              getRowId={(row) => row?.id}
              components={{ Toolbar: QuickSearchToolbar }}
            />
          </Box>}
      </CardContent>
    </Card>
  </>
);
}
export default ViewAllPendingRejections;

